// src/pages/userprofile/admin/AdminUserprofilePage.tsx
// Userprofile admin console — profile directory/moderation + media repair
// tools. Admin-gated (AdminRoute, in App.tsx). See docs/ux/userprofile-ia.md.

import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { observer } from '@react';
import { useI18n } from '@react/hooks';
import { AdminDirectoryPanel } from '@/features/userprofile/AdminDirectoryPanel';
import { MediaAdminPanel } from '@/features/userprofile/MediaAdminPanel';

type Tab = 'directory' | 'media';
const TABS: Tab[] = ['directory', 'media'];

export const AdminUserprofilePage = observer(() => {
  const { t } = useI18n();
  const [searchParams, setSearchParams] = useSearchParams();

  const tab = useMemo<Tab>(() => {
    const v = searchParams.get('tab');
    return (TABS as string[]).includes(v ?? '') ? (v as Tab) : 'directory';
  }, [searchParams]);

  return (
    <div className="space-y-4 p-6">
      <div>
        <h1 className="text-xl font-semibold text-foreground">{t('userprofile.admin.title')}</h1>
        <p className="text-sm text-muted-foreground">{t('userprofile.admin.subtitle')}</p>
      </div>

      <div role="tablist" aria-label={t('userprofile.admin.title')} className="flex flex-wrap gap-1 border-b border-border">
        {TABS.map((v) => (
          <button
            key={v}
            type="button"
            role="tab"
            aria-selected={tab === v}
            onClick={() => setSearchParams({ tab: v })}
            className={`-mb-px border-b-2 px-3 py-2 text-sm ${
              tab === v ? 'border-primary font-medium text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground'
            }`}
          >
            {t(`userprofile.admin.tab.${v}`)}
          </button>
        ))}
      </div>

      {tab === 'directory' && <AdminDirectoryPanel />}
      {tab === 'media' && <MediaAdminPanel />}
    </div>
  );
});

export default AdminUserprofilePage;
